"use client";

import SentryErrorComponent from "@stadium/services/error-reporting/app/error";

import ErrorComponent from "@components/500";

export default function GlobalError({ error }) {
  return <SentryErrorComponent error={error} ErrorComponent={ErrorComponent} />;
}
